import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Regexs } from '@utils/regex';

@Component({
  selector: 'app-suministro-informacion',
  templateUrl: './suministro-informacion.component.html',
  styleUrls: ['./suministro-informacion.component.scss'],
})
export class SuministroInformacionComponent implements OnInit {
  form: FormGroup;

  @Input() data: { task: any };

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    const { task } = this.data;
    const values = task.data ? task.data : null;
    this.form = this.fb.group({
      fecha_solicitud: [
        values ? values.fecha_solicitud : '',
        [Validators.required],
      ],
      numero_solicitud: [
        values ? values.numero_solicitud : '',
        [Validators.required, Validators.pattern(/^[0-9]\d*$/)],
      ],
      fecha_procesado: [
        values ? values.fecha_procesado : '',
        [Validators.required],
      ],
      fecha_enviado: [
        values ? values.fecha_enviado : '',
        [Validators.required],
      ],
      ente_solicita: [
        values ? values.ente_solicita : '',
        [Validators.required],
      ],
      direccion_carreo: [
        values ? values.direccion_carreo : '',
        [Validators.required, Validators.pattern(Regexs.EMAIL_REGEX)],
      ],
      descripcion_solicitud: [
        values ? values.descripcion_solicitud : '',
        [Validators.required],
      ],
    });
  }

  verificateInput(value: string) {
    return (
      this.form.get(value)?.invalid &&
      (this.form.get(value)?.dirty || this.form.get(value)?.touched)
    );
  }
}
